import { Component } from '@angular/core'

@Component({
  selector: 'ao-navigation-header',
  templateUrl: './navigation-header.component.html',
  imports: [],
})
export class NavigationHeaderComponent {}
